// @ts-check

/**
 * Mapbox event handler utilities.
 * Provides functions for setting up map interaction handlers (click, hover, etc.).
 */

/**
 * Setup click handler for island markers.
 * @param {import('mapbox-gl').Map} map - Mapbox map instance
 * @param {string} layerId - Layer ID to attach handler to
 * @param {Function} onIslandClick - Callback when island is clicked
 */
export function setupIslandClickHandler(map, layerId, onIslandClick) {
  map.on("click", layerId, (event) => {
    const feature = event.features[0];
    onIslandClick(feature);
  });
}

/**
 * Setup hover handlers for island markers (cursor only).
 * Labels are handled by Mapbox's native symbol layer, so we only need cursor changes here.
 * @param {import('mapbox-gl').Map} map - Mapbox map instance
 * @param {string} layerId - Layer ID to attach handlers to
 * @returns {Object} Object with cleanup function
 */
export function setupIslandHoverHandlers(map, layerId) {
  // Change cursor on hover
  map.on("mouseenter", layerId, () => {
    map.getCanvas().style.cursor = "pointer";
  });

  // Reset cursor on leave
  map.on("mouseleave", layerId, () => {
    map.getCanvas().style.cursor = "";
  });

  return {
    cleanup: () => {
      // No cleanup needed for simple cursor handlers
    }
  };
}
